export const locationSample = [
  {
    key: 1,
    tableData: [
      {
        serial: "1",
        location: "Delhi",
        description: "Lorem ipsum",
      },
    ],
  },
  {
    key: 2,
    tableData: [
      {
        serial: "2",
        location: "Gurgaon",
        description: "Lorem ipsum",
      },
    ],
  },
  {
    key: 3,
    tableData: [
      {
        serial: "3",
        location: "Banglore",
        description: "Lorem ipsum",
      },
    ],
  },
  {
    key: 4,
    tableData: [
      {
        serial: "4",
        location: "Mumbai",
        description: "Lorem ipsum",
      },
    ],
  },
  {
    key: 5,
    tableData: [
      {
        serial: "5",
        location: "Hyderabad",
        description: "Lorem ipsum",
      },
    ],
  },
  {
    key: 6,
    tableData: [
      {
        serial: "6",
        location: "Ranchi",
        description: "Lorem ipsumasdasd asdasd asdasdasdasd asdasfdasfafsas ",
      },
    ],
  },
  {
    key: 7,
    tableData: [
      {
        serial: "7",
        location: "Mumbai",
        description: "Lorem ipsum",
      },
    ],
  },
  {
    key: 8,
    tableData: [
      {
        serial: "8",
        location: "Hyderabad",
        description: "Lorem ipsum",
      },
    ],
  },
  {
    key: 9,
    tableData: [
      {
        serial: "9",
        location: "Mumbai",
        description: "Lorem ipsum",
      },
    ],
  },
  {
    key: 10,
    tableData: [
      {
        serial: "10",
        location: "Ranchi",
        description: "Lorem ipsum",
      },
    ],
  },
];
